import { showToast } from '../components/kid/Toast';

/**
 * Save without making people wait (2026-10-13, Jens): the form closes at once, a message says
 * "Saving…", then "Saved". If it fails, the message says so and offers "Try again", which sends
 * exactly the same changes again — nothing the person typed is lost.
 */
export function saveInBackground(opts: {
  run: () => Promise<unknown>;
  saving: string;
  saved: string;
  failed: string;
  tryAgain: string;
}): Promise<boolean> {
  const attempt = async (): Promise<boolean> => {
    showToast({ message: opts.saving, durationMs: 120000 });
    try {
      await opts.run();
      showToast({ message: opts.saved, durationMs: 2500 });
      return true;
    } catch (error) {
      console.error('saveInBackground:', error);
      showToast({ message: opts.failed, tone: 'error', durationMs: 30000, actionLabel: opts.tryAgain, onAction: () => { void attempt(); } });
      return false;
    }
  };
  return attempt();
}
